import React from 'react';
import PropTypes from 'prop-types';

const GuestName = ({ firstName, lastName, className, children }) => <span className={className}>{firstName}&nbsp;{lastName} {children}</span>;

GuestName.propTypes = {
  className: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  children: PropTypes.any,
};

export default GuestName;



// WEBPACK FOOTER //
// ./src/components/molecules/GuestName/index.js